import React from "react";
import styled from "styled-components";

const CategoryCard = ({ icon, children, height, width, onClick }) => {
  return (
    <Card
      height={height}
      width={width}
      onClick={() => (onClick ? onClick() : null)}
    >
      {icon && <div className="CategoryCard__background-img">{icon}</div>}
      <div>{children}</div>
    </Card>
  );
};

const Card = styled.div`
  cursor: pointer;
  border-radius: 8px;
  box-shadow: 0 2px 8px 0 rgba(34, 41, 57, 0.1);
  background-color: #ffffff;
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 16px;
  letter-spacing: 0.4px;
  font-weight: 600;
  line-height: 1.5;
  color: #000000;
  padding: 0 14px;
  overflow: hidden;
  height: ${props => (props.height ? `${props.height}px` : "64px")};
  width: ${props => (props.width ? `${props.width}px` : "auto")};
  transition: box-shadow 0.3s ease-in-out;

  /* Safari Only */
  @media not all and (min-resolution: 0.001dpcm) {
    @supports (-webkit-appearance: none) {
      font-weight: 900 !important;
    }
  }

  :hover {
    box-shadow: 0 4px 20px 0 rgba(34, 41, 57, 0.15);
  }

  .CategoryCard__background-img {
    height: 100%;
    margin: -8px 4px -8px -16px;
    border-radius: unset;
    img {
      height: 100%;
    }
  }
`;

export default CategoryCard;



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/search/categoriesCards/CategoryCard.js